import React from 'react';
import { IonContent, IonLoading, IonPage, useIonViewWillEnter } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ReviewClinicType, useReviewClinicQuery } from '../../generated/graphql';
import { ErrorNetwork } from '../../components/error/ErrorNetwork';
import { Title } from '../../components/title/Title';
import { ReviewClinicDetail } from '../../components/review-clinic/ReviewClinicDetail';

const ReviewClinicPage = () => {
  const { id } = useParams() as { id: string };
  const { t } = useTranslation();

  const { data, loading, error, refetch } = useReviewClinicQuery({ variables: { id }, fetchPolicy: 'no-cache' });

  useIonViewWillEnter(() => {
    if (data) refetch();
  }, [data]);

  if (loading || !data?.reviewsClinic) {
    return <IonLoading isOpen={loading} message={t('Loading...')} />;
  }

  if (error) {
    return <ErrorNetwork error={error} />;
  }

  return (
    <IonPage>
      <Title color="primary" translucent title="" backButton />
      <IonContent>{data && <ReviewClinicDetail clinic={data.reviewsClinic as ReviewClinicType} />}</IonContent>
    </IonPage>
  );
};

export { ReviewClinicPage };
